import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../PartnerOptions/constants'

import {
  fetchCampaignsError,
  fetchCampaignsSuccess,
  fetchReportError,
  fetchReportSuccess,
  getCacheKeyError,
  getCacheKeySuccess,
} from './actions'
import {
  CACHE_KEY_REQUEST_ASYNC,
  CAMPAIGN_FILTER_CHANGE,
  CAMPAIGNS_REQUEST_ASYNC,
  DATE_FILTER_CHANGE,
  REPORT_REQUEST_ASYNC,
} from './constants'
import { selectCacheKey, selectDateRange, selectSelectedCampaignIds } from './selectors'

const shouldIncludeAction = (action) => {
  const { type, payload } = action

  if (type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS) {
    return matchURL(URL_CONST.dashboard.awareness)
  }

  if (type === CAMPAIGN_FILTER_CHANGE && !payload.withCustomIds) {
    return false
  }

  if (type === DATE_FILTER_CHANGE && !payload?.isNeedsFetch) {
    return false
  }

  return true
}

const fetchCampaignsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      CAMPAIGNS_REQUEST_ASYNC.INITIATE,
      DATE_FILTER_CHANGE,
      CAMPAIGN_FILTER_CHANGE
    )
    .filter(shouldIncludeAction)
    .mergeMap((action) => {
      const statusFilter = action.payload?.filters?.statusFilter.map((id) => parseInt(id))
      const searchFilter = action.payload?.filters?.searchFilter
      const languagesFilter = action.payload?.filters?.languagesFilter
      const selectAll = action.payload?.filters?.selectAll
      const excludedIds = action.payload?.filters?.excludedIds
      const dateFilter =
        action.payload?.dateFilter === null || action.payload?.dateFilter
          ? action.payload?.dateFilter
          : selectDateRange(store.getState())

      return api.dashboard
        .getCampaignsIds(
          store.getState().partnerOptions.selectedCompany?.value,
          dateFilter,
          selectSelectedCampaignIds(store.getState()),
          statusFilter,
          languagesFilter,
          searchFilter,
          selectAll,
          excludedIds
        )
        .map((response) => fetchCampaignsSuccess(response.response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchCampaignsError, error)))
        .takeUntil(action$.ofType(CAMPAIGNS_REQUEST_ASYNC.CANCEL))
    })

const getCacheKeyEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(CAMPAIGNS_REQUEST_ASYNC.SUCCESS, CAMPAIGN_FILTER_CHANGE)
    .filter((action) => {
      if (action.type === CAMPAIGN_FILTER_CHANGE && action.payload.withCustomIds) return false
      return selectSelectedCampaignIds(store.getState())?.length > 1
    })
    .mergeMap(() =>
      api.dashboard
        .getAwarenessCacheKey(
          store.getState().partnerOptions.selectedCompany?.value,
          selectSelectedCampaignIds(store.getState())
        )
        .map((response) => getCacheKeySuccess(response.response))
        .catch((error) => Observable.of(epicsErrorHandler(getCacheKeyError, error)))
        .takeUntil(action$.ofType(CACHE_KEY_REQUEST_ASYNC.CANCEL))
    )

const fetchReportEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(REPORT_REQUEST_ASYNC.INITIATE)
    .filter(() => store.getState().dashboard?.awareness.self.data.selectedCampaignIds?.length > 1)
    .mergeMap(() =>
      api.dashboard
        .getAwarenessData(
          store.getState().partnerOptions.selectedCompany?.value,
          selectCacheKey(store.getState())
        )
        .map((response) =>
          typeof response === 'string' ? getCacheKeySuccess(response) : fetchReportSuccess(response)
        )
        .catch((error) => Observable.of(epicsErrorHandler(fetchReportError, error)))
        .takeUntil(action$.ofType(CAMPAIGNS_REQUEST_ASYNC.CANCEL))
    )

export default combineEpics(fetchCampaignsEpic, getCacheKeyEpic, fetchReportEpic)
